import React from "react";

const UpdateContactPage = ({ formData, handleChange, handleSubmit, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Contact Page</h2>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Phone */}
        <div className="mb-4">
          <label className="block text-gray-700">Phone</label>
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Address */}
        <div className="mb-4">
          <label className="block text-gray-700">Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            className="border w-full p-2"
            required
          ></textarea>
        </div>

        {/* Headline */}
        <div className="mb-4">
          <label className="block text-gray-700">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>

        {/* Paragraph */}
        <div className="mb-4">
          <label className="block text-gray-700">Paragraph</label>
          <textarea
            name="paragraph"
            value={formData.paragraph}
            onChange={handleChange}
            className="border w-full p-2"
            required
          ></textarea>
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Update Contact Page
        </button>
      </form>
    </div>
  );
};

export default UpdateContactPage;
